import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";
import { FC } from "react";

import { fixedHeight, fixedWidth } from "~/lib/client/design";
import { font } from "~/lib/client/fonts";

const WriteButton: FC<{ height?: string; openModal: () => void }> = ({
  openModal,
  height,
}) => {
  const theme = useTheme();
  return (
    <div
      role={"button"}
      css={writeButtonStyle(theme, height)}
      className={font.className}
      onClick={openModal}
    >
      書き込む
    </div>
  );
};

const writeButtonStyle = (theme: Theme, height?: string) => css`
  ${fixedWidth("14rem")}
  ${fixedHeight(height || "2.5rem")}
  background-color: ${theme.palette.primary.main};
  color: ${theme.palette.primary.contrastText};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default WriteButton;
